<template>
  <footer class="dtva-footer">
    <div
      class="dtva-footer__slogan"
    >
      <!-- eslint-disable -->
      <a class="dtva-header__name">{{ this.$i18n.t('APP.LOGO.DREI') }}<span class="text--blue">{{ this.$i18n.t('APP.LOGO.TV') }}</span></a>
      <!-- eslint-enable -->
    </div>
    <div
      class="dtva-footer__content"
    >
      <nav
        class="dtva-footer__nav-entries"
        aria-label="Footer"
      >
        <a
          class="dtva-footer__nav-entry"
          href="/de/footernavigation/agb/"
          target="_blank"
        >
          {{ this.$i18n.t('APP.BOTTOM_MENU.TOS') }}
        </a>
        <a
          class="dtva-footer__nav-entry"
          href="/de/footernavigation/impressum/"
          target="_blank"
        >
          {{ this.$i18n.t('APP.BOTTOM_MENU.IMPRINT') }}
        </a>
        <a
          class="dtva-footer__nav-entry"
          href="/de/footernavigation/datenschutz/"
          target="_blank"
        >
          {{ this.$i18n.t('APP.BOTTOM_MENU.DATA_PROTECTION') }}
        </a>
        <!-- OneTrust Cookies Settings button start -->
        <button
          id="ot-sdk-btn"
          class="ot-sdk-show-settings"
        >
          Cookie Settings
        </button>
        <!-- OneTrust Cookies Settings button end -->
      </nav>
      <span class="dtva-footer__copy">{{ this.$i18n.t('APP.BOTTOM_MENU.COPYRIGHT') }}</span>
    </div>
  </footer>
</template>

<script>
    export default {
        name: "DtvaFooter"
    }
</script>

<style lang="scss" src="./dtva-footer.scss">
</style>
